module.exports = __webpack_public_path__ + "static/media/EventPlanner.221123c6.jpg";